import React from 'react';


function TapOn() {
  return (
    <svg width="13" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.27504 0.333344H9.77504C9.99605 0.333344 10.208 0.421141 10.3643 0.577421C10.5206 0.733701 10.6084 0.945663 10.6084 1.16668C10.6084 1.38769 10.5206 1.59965 10.3643 1.75593C10.208 1.91221 9.99605 2.00001 9.77504 2.00001H3.28337L12.7667 11.4833C12.9219 11.6395 13.009 11.8507 13.009 12.0708C13.009 12.291 12.9219 12.5022 12.7667 12.6583C12.6115 12.8123 12.402 12.8991 12.1834 12.9C12.0737 12.9006 11.965 12.8796 11.8635 12.8382C11.7619 12.7967 11.6696 12.7356 11.5917 12.6583L2.10837 3.17501V9.66668C2.10837 9.88769 2.02058 10.0997 1.8643 10.2559C1.70801 10.4122 1.49605 10.5 1.27504 10.5C1.05403 10.5 0.842065 10.4122 0.685784 10.2559C0.529504 10.0997 0.441706 9.88769 0.441706 9.66668V1.16668C0.441706 0.945663 0.529504 0.733701 0.685784 0.577421C0.842065 0.421141 1.05403 0.333344 1.27504 0.333344Z" fill="#001325" fillOpacity="0.48"/>
    </svg>
  );
};

export default TapOn;
